export const CAMUNDA_URL =
  'https://camunda.hrc-dashboard.saicinnovationfactory.com';
